import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, Spinner } from '../../../../common';
import { SortAscendingOutlined } from '@ant-design/icons';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import SectionsTable from './Order/SectionsTable.jsx';
import {
  useDeleteSectionMutation,
  useGetSectionsQuery,
} from '../../../../../redux/services/yellow_books';

const SectionsPage = () => {
  const { t } = useTranslation();
  const { yellowBookId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('Sekcie žltej knižky') + ' - FRI CMS';
  }, []); // Runs on mount

  const { deleteSuccess: showDeleteSuccess } = useToastMessages();

  const {
    data: yellowBook,
    isLoading,
    refetch,
  } = useGetSectionsQuery(yellowBookId);

  const [deleteSection, { isSuccess: isDeleteSuccess }] =
    useDeleteSectionMutation();

  useEffect(() => {
    if (isDeleteSuccess) {
      showDeleteSuccess();
      refetch();
    }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={`${t('Sekcie žltej knižky')} "${yellowBook?.title || ''}"`}
        backUrl={routes.cmsYellowBooks}
        backUrlTooltip={t('Žltá knižka')}
        createText={t('Pridať sekciu')}
        createUrl={routes.cmsYellowBookSectionsCreate(yellowBookId)}
        permissionsBasic="yellow-books"
        mainActions={[
          {
            onClick: () =>
              navigate(routes.cmsYellowBookSectionsOrder(yellowBookId)),
            title: t('Zoradiť menu'),
            icon: <SortAscendingOutlined />,
            permission: 'yellow-books.show',
          },
        ]}
      />
      <CollapseBlock>
        <SectionsTable
          sections={yellowBook?.sections}
          onDetailClick={(record) =>
            navigate(routes.cmsYellowBookSectionsEdit(yellowBookId, record.id))
          }
          onDelete={(record) =>
            deleteSection({ yellowBookId, sectionId: record.id })
          }
        />
      </CollapseBlock>
    </>
  );
};

export default SectionsPage;
